/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorDetailView} from "../../vendor/views/VendorDetailView";
const route = [{webpackEntry: "vendorDetail", path: rpAppPath.vendor.detail.base, component: VendorDetailView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {VendorDetailView} from "../../vendor/views/VendorDetailView";
const route = [{webpackEntry: "vendorDetail", path: rpAppPath.vendor.detail.base, component: VendorDetailView}];

(function () {
    rpClient(route);
})();
